import PageWrapper from '@app/components/layout/PageWrapper';
import FullLoader from '@app/components/ui/FullLoader';
import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';

const InventoryCategoriesPage = lazy(() => import('@pages/inventoryCategories/InventoryCategoriesPage'));

// Route Component
const InventoryCategoryTablePage = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('inventory-categories-page-title')}>
        <InventoryCategoriesPage />
      </PageWrapper>
    </Suspense>
  );
};

// Export Lazy-Loaded Route
export default {
  InventoryCategoryTablePage,
};
